import React, { useEffect} from 'react';
import { Col, Container, Row } from "reactstrap";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import {Config} from "../../../Utils/Config";
import { apiCommonTrigger, apiCommonTriggerBlob } from '../../../Utils/apiServicehelper';

const MarketPaymentSuccess = (props) => {
    const [isLoading, setLoading] = React.useState(false);
    const [cartDetails, setCartDetails] = React.useState([]);
    const [downloadStatus, setDownloadStatus] = React.useState('null');
    const [timeLeft, setTimeLeft] = React.useState(15);
    const [paymentActivation, setPaymentActivation] = React.useState(null);
    const search = useLocation().search;
    const sessionId = new URLSearchParams(search).get('session_id');
    const checkoutSessionId = new URLSearchParams(search).get('checkout_session');
    const navigate = useNavigate();

    const getReport = () => {
        const apiPath = process.env.REACT_APP_API_URL;
        setLoading(true);
        const payload = {
            "securityKey": sessionId,
        }
        apiCommonTriggerBlob("post",`${Config.API_URL}/markets/market/report/download`, payload).then((res) => {
                // return res;
                if (res.status === 200) {
                    const filename = res.headers['content-disposition'].split('filename=')[1];
                    const str = filename;
                    const before_ = str.substring(0, str.indexOf(';'));
                    const blob = new Blob([res.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', before_);
                    document.body.appendChild(link);
                    // this.setState({ link })
                    link.click();
                    window.URL.revokeObjectURL(url)
                    setLoading(false);
                } else if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch(error => {
                handlingCatchError(error);
                setLoading(false);
                console.log(error);
            });
    }

    useEffect(() => {
        async function getPaymentStatus() {
           
            await   apiCommonTrigger("get",`${Config.API_URL}/subscription/checkoutusermarket/`,[sessionId,checkoutSessionId]).then((res) => {
                if (res.status === 200) {
                    setPaymentActivation(true);
                    if(res.data.marketid !== 0){
                        getReport();
                    }
                }
                else{ 
                    setLoading(false)
                    handlingCatchError(res, navigate);
                  }
            })
            .catch(err => {
                setLoading(false)
                handlingCatchError(err, navigate);
              })
        }

        async function fetchMyAPI() {
            if (downloadStatus === 'null') {
                setLoading(true);
                await apiCommonTrigger("get" , Config.API_URL + '/subscription/checkoutmarketdet/' , [sessionId])
                .then((res) => {
                    if (res.status === 200) {
                        setCartDetails(res.data.marketCartDet);
                        setDownloadStatus(res.data.marketCartDet.activity);
                        setLoading(false);
                    }
                    else{ 
                        setLoading(false)
                        handlingCatchError(res, navigate);
                      }
                })
                .catch(err => {
                    setLoading(false)
                    handlingCatchError(err, navigate);
                  })
            }
        }
        if(paymentActivation === null){
            getPaymentStatus();
        }
        if(downloadStatus === 'null'){
            fetchMyAPI();
        }

        if (timeLeft === 0 && paymentActivation === true) {
            setTimeLeft(15);
            loadReportDetails();
        }

        // exit early when we reach 0
        if (!timeLeft) return;

        // save intervalId to clear the interval when the
        // component re-renders
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 10000);

        // clear interval on re-render to avoid memory leaks
        return () => clearInterval(intervalId);
        // add timeLeft as a dependency to re-rerun the effect
        // when we update it
    }, [timeLeft]);

    const loadReportDetails = () => {
        if (downloadStatus === 'Not Yet Started' || downloadStatus === 'InProgress') {
            setLoading(true);
            apiCommonTrigger("get" , Config.API_URL + '/subscription/checkoutmarketdet/' , [sessionId])
            .then((res) => {
                if (res.status === 200) {
                    setCartDetails(res.data.marketCartDet);
                    setDownloadStatus(res.data.marketCartDet.activity);
                    setLoading(false);
                }
                else{ 
                    setLoading(false)
                    handlingCatchError(res, navigate);
                  }
            })
            .catch(err => {
                setLoading(false)
                handlingCatchError(err, navigate);
              })
        }
    };

    return (
        <div className='thank-you-page'>
            {isLoading ? (
                <div className="loader-wrap">
                    <div className="default-page loading loading-center"></div>
                </div>
            ) : (
                ""
            )}
            <Container>
                <Row>
                    {paymentActivation === true ?
                    <Col xs={12}>
                        <div className="sec-msg">
                            <Paper className="p-4 elevation0 thank-table" component="div" align="center" >
                                <Typography variant="h3" component="h3" className="pb-4 thank-you" >
                                    Thank you for your purchase!
                                </Typography>
                                <Typography variant="h6" component="h6" className="pb-3">
                                    You will get an order confirmation email shortly.
                                </Typography>
                                <Typography variant="body2" className="fin-txt">
                                    <p style={{ marginBottom: '5px' }}>Market Reports may take up to several minutes to generate. When ready, click on the Download Link to view the PDF report.
                                        {/* Historical Pricing Reports are available within one business day from day of purchase. A link will be sent to you to download the report in Excel. */}</p>
                                    <p>If you need to close this window, you can re-open it by clicking the link in the email confirmation sent to you.</p>
                                </Typography>
                                <div className="promoCode_btn pt-2 pb-0">
                                    <Table className="table table-bordered custom-table payment-table table-design" style={{ marginBottom: '10px' }}>
                                        <TableHead>
                                            <TableRow className="table-header">
                                                <TableCell>Report Type</TableCell>
                                                <TableCell>Market</TableCell>
                                                <TableCell>Coverage</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Download link</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {cartDetails ?
                                                <TableRow>
                                                    <TableCell>Market Report</TableCell>
                                                    <TableCell>{cartDetails.address ? cartDetails.address : '-'}</TableCell>
                                                    <TableCell>{cartDetails.radius ? cartDetails.radius === 1 ? cartDetails.radius + ' miles radius' : cartDetails.radius + ' miles radius' : '-'}</TableCell>
                                                    <TableCell>{cartDetails.activity == 'InProgress' ? 'In Progress' : cartDetails.activity}</TableCell>
                                                    <TableCell > {cartDetails.activity == 'Success' ? <a href='#' className={isLoading ? 'disabled-link' : ''} onClick={() => getReport()}> Click Here </a> : cartDetails.activity == 'InProgress' ? <span className="loader-xcel"></span> : ' --- '}</TableCell>
                                                </TableRow> :
                                                <TableRow>
                                                    <TableCell colSpan={5} className="no-data" >{isLoading ? '' : 'Cart details not available'}</TableCell>
                                                </TableRow>}
                                        </TableBody>
                                    </Table>
                                </div>
                                <Typography component="p" className="pt-2 mb-0 text-center" style={{ paddingBottom: '15px', textAlign: 'left', fontSize: '14px' }} gutterBottom>
                                    <b>Don’t Forget! Your purchase also includes access to the RVParkIQ platform</b> for 30 days where you can access additional market information For access, click below to sign in!
                                </Typography>
                                <Typography component="p" gutterBottom className="mb-3">
                                    <Link to={"/signin"} target="_blank" className="market-btn btn btn-secondary">Go to my RVParkIQ Account</Link>
                                </Typography>
                                <Divider />
                                <Typography component="p" className="pt-3 mb-0 font13 opacity-7" gutterBottom>
                                    Questions? Contact us at {Config.PhoneNumber} or <a href={'mailto:'+Config.supportEmail} className="email-conform">{Config.supportEmail}</a>
                                    {/* Questions? Contact us at {CONFIG.Sales} or */}
                                </Typography>

                            </Paper>
                        </div>
                    </Col>
                    :
                    <Col xs={12}>
                        <div className="sec-msg">
                            <p className='text-center please-wait-txt'>Please wait! Do not refresh/close the page your payment is processing...</p>
                        </div>
                    </Col>
                    }
                </Row>
            </Container>
        </div>
    );
}

export default MarketPaymentSuccess;